




























import { Component, Mixins, Prop } from "vue-property-decorator";
import mixins from "../mixins";
@Component
export default class FitCheckbox extends Mixins(mixins) {
  @Prop({ default: "#ffffff" }) fill;
  @Prop({ default: 36 }) size;
}
